// <copyright file="auth-token-store.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 12/29/2025 by Sumanth Satheesh
// </copyright>

import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
// Defines AuthTokenStore.
export class AuthTokenStore {
  private readonly KEY = "access_token";

  setAccessToken(token: string | null) {
    if (token) {
      sessionStorage.setItem(this.KEY, token);
    } else {
      sessionStorage.removeItem(this.KEY);
    }
  }

  // Retrieve token - sync with sessionStorage on first access
  getAccessToken(): string | null {
    return sessionStorage.getItem(this.KEY);
  }

  clear() {
    sessionStorage.removeItem(this.KEY);
  }
}
